function copyToClipboard(text) {

  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(text).select();
  document.execCommand("copy");
  $temp.remove();
}
 
$(document).ready(function() {

  $(".share-links").on("click", "a.Email-copy", function(e) {
    e.preventDefault(); 
    e.stopPropagation(); 

    var $this = $(this);
    var copyText = $this.attr("data-copy");
    var $hoverText = $this.closest("li").find(".hover-email");

    copyToClipboard(copyText);

    // show "Copied!" for this icon only
    $hoverText.text("Copied!");
    setTimeout(function() {
      $hoverText.text(""); 
    }, 500);
  });

  $(".share-links").on("keydown", "a.Email-copy", function(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $(this).trigger("click");
    }
  });
});


(function($) {
  function cleanPriceIds($modal) {
    if (!$modal || !$modal.length) return;

    $modal.find('.main-pdp-coll-popup-data .price-quickadd').each(function() {
      const $el = $(this);
      const id = $el.attr('id');
      if (id && id.includes('duplicate-')) {
        $el.attr('id', id.replace('duplicate-', ''));
      }
    });
  }

  $(document).on('click', '.quick-add__submit', function() {
    setTimeout(function() {
      cleanPriceIds($('.quick-add-modal[open]'));
    }, 250); 
  });

  function observeModal($modal) {
    if (!$modal.length) return;
    const el = $modal[0];

    if (el.__observingOpen) return;
    el.__observingOpen = true;

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.attributeName === 'open' && $modal.is('[open]')) {
          setTimeout(() => cleanPriceIds($modal), 50);
        }
      }
    });
    mo.observe(el, { attributes: true });
  }
  $('.quick-add-modal').each(function() { observeModal($(this)); });

  const bodyMO = new MutationObserver(() => {
    $('.quick-add-modal').each(function() { observeModal($(this)); });
  });
  bodyMO.observe(document.documentElement, { childList: true, subtree: true });

})(jQuery);




$(document).on("click","[name='properties[Logocut]']",function(){
    let mediaUrl = $(this).parents(".product").find("media-gallery [alt=logo-cut]").attr("src");
    let mediaUrlSrcset = $(this).parents(".product").find("media-gallery [alt=logo-cut]").attr("srcset");
    let mediaUrl1 = $(this).parents(".product").find("media-gallery [alt=logo-cut]").parents(".product__media-item").next(".product__media-item").find(".product__media img").attr("src");
    let mediaUrlSrcset1 = $(this).parents(".product").find("media-gallery [alt=logo-cut]").parents(".product__media-item").next(".product__media-item").find(".product__media img").attr("srcset");
    if($(this).is(":checked"))
    {
        $(this).parents(".product__info-container").find("input[type='hidden'][name='properties[Logocut]']").val("Enabled");
          let logoCutThumbnail = document.querySelector('.thumbnail-list__item[data-alt="logo-cut"] button');
            if (logoCutThumbnail) {
              logoCutThumbnail.click(); // Simulate clicking the logo-cut thumbnail button
            }

    }
    else
    {
        $(this).parents(".product__info-container").find("input[type='hidden'][name='properties[Logocut]']").val("Disabled");
    }
    $(this).parents(".product").find("media-gallery [alt=logo-cut]").attr("src",mediaUrl1);
    $(this).parents(".product").find("media-gallery [alt=logo-cut]").attr("srcset",mediaUrlSrcset1);
    $(this).parents(".product").find("media-gallery [alt=logo-cut]").parents(".product__media-item").next(".product__media-item").find(".product__media img").attr("src",mediaUrl);
    $(this).parents(".product").find("media-gallery [alt=logo-cut]").parents(".product__media-item").next(".product__media-item").find(".product__media img").attr("srcset",mediaUrlSrcset);
});

$(document).on("click",".related-atc",function(e){
    e.preventDefault();
    $(this).attr("disabled","disabled");
    const cartDrawer = document.querySelector("cart-drawer");
    let vid = $(this).attr("data-variant-id");
    let qty = 1;
    fetch(`${routes.cart_add_url}.js`, {
        method:"POST",
        headers:{
            "Content-type":"application/json",
        },
        body:JSON.stringify({
            items:[
                {
                    quantity:qty,
                    id:vid,
                },
            ],
            sections: cartDrawer.getSectionsToRender().map((section) => section.id)
        })
    })
        .then((response) => response.json())
        .then((response) => {
        cartDrawer.renderContents(response);
        });
});

$(document).on("click",".cart-related-atc",function(e){
    e.preventDefault();
    $(this).attr("disabled","disabled");
    let _btn = $(this);
    const cartDrawer = document.querySelector("cart-drawer");
    const cartitem = document.querySelector("cart-items");
    let vid = $(this).attr("data-variant-id");
    let qty = 1;
    fetch(`${routes.cart_add_url}.js`, {
        method:"POST",
        headers:{
            "Content-type":"application/json",
        },
        body:JSON.stringify({
            items:[
                {
                    quantity:qty,
                    id:vid,
                },
            ],
            sections: cartitem.getSectionsToRender().map((section) => section.id)
        })
    })
        .then((response) => response.json())
        .then((response) => {
            cartitem.onCartUpdate();
            fetch(`${routes.cart_url}?section_id=main-cart-footer`)
            .then((response) => response.text())
            .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.js-contents');
            document.querySelector("#main-cart-footer .js-contents").innerHTML = sourceQty.innerHTML;
            })
            .catch((e) => {
            console.error(e);
            });
            _btn.removeAttr("disabled");
        });
});


if($(".related-products .related-product-item").length != 0)
{
    // if(!$(".related-product-items").hasClass("slick-initialized"))
    // {
    // $(".cart-related-products .cart-related-product-items").slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     arrows: true,
    //     dots: true,
    //     infinite: false,
    //     prevArrow: $(".cart-related-products").find('.custom-prev'),
    //     nextArrow: $(".cart-related-products").find('.custom-next'),
    //     touchThreshold: 25,
    //     swipe:true,
    //     swipeToSlide:true,
    //     responsive: [
    //     {
    //         breakpoint: 1024,
    //         settings: { slidesToShow: 3.6,slidesToScroll: 3.6 }
    //     },
    //     {
    //         breakpoint: 768,
    //         settings: { slidesToShow: 2.6,slidesToScroll: 2.6 }
    //     },
    //     {
    //         breakpoint: 575,
    //         settings: { slidesToShow: 1.6,slidesToScroll: 1.6 }
    //     }
    //     ]
    // });
    // }
    
    
}
else
{
    $(".cart-related-products").hide();
}


var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}



const details = document.querySelectorAll('.details-header-menu');

details.forEach(function(detail){
    detail.addEventListener('mouseenter', () => {
        detail.setAttribute('open', true);
    });

    detail.addEventListener('mouseleave', () => {
        detail.removeAttribute('open');
    });
});


document.addEventListener('DOMContentLoaded', function () {
    
    // if($("product-recommendations").length != 0)
    // {
    //     const relatedProductInterval = setInterval(loadRelatedProducts, 500);
    //     function loadRelatedProducts() {
    //         let items = $("product-recommendations .product-grid li").length;
    //         if(items != 0)
    //         {
    //             clearInterval(relatedProductInterval);
    //             const $prev = $("product-recommendations").find('.custom-prev');
    //             const $next = $("product-recommendations").find('.custom-next');

    //             $("product-recommendations .product-grid").slick({
    //                 slidesToShow: 4,
    //                 slidesToScroll: 4,
    //                 arrows: true,
    //                 dots: true,
    //                 infinite: false,
    //                 prevArrow: $prev,
    //                 nextArrow: $next,
    //                 touchThreshold: 25,
    //                 responsive: [
    //                 {
    //                     breakpoint: 1025,
    //                     settings: { slidesToShow: 3.5,slidesToScroll: 1 }
    //                 },    
    //                 {
    //                     breakpoint: 768,
    //                     settings: { slidesToShow: 2.5,slidesToScroll: 1 }
    //                 },
    //                 {
    //                     breakpoint: 600,
    //                     settings: { slidesToShow: 1.6,slidesToScroll: 1 }
    //                 }
    //                 ]
    //             });
    //         }
    //     }
    // }

    const videoPlayButton = document.querySelectorAll(".video-grid-card .play-icon");
    videoPlayButton.forEach(function(control){
        control.addEventListener("click",function(e){
            e.preventDefault();
            e.stopPropagation();
            let video = this.closest(".video").querySelector("video");
            if(this.classList.contains("active"))
            {
                video.pause();
            }
            else
            {
                video.play();
            }
            this.classList.toggle('active');
        });
    });
        
});

// footer toggle js 
$(document).ready(function(){
  $(".footer-block__heading").click(function(){
    $(this).next().toggleClass("f-active");
    $(this).toggleClass("f-active-arrow");
    // $(this).next().slideDown();
  });
});
